export default "__VITE_ASSET__fEuKJlXE__";